export function formatCurrency(val) {
  return Number(val || 0).toLocaleString("en-US", {
    style: "currency",
    currency: "USD",
  });
}

export function formatNumber(val) {
  return Number(val || 0).toLocaleString("en-US");
}

export function getCostToProfit(totalPurchased, totalProfit) {
  const purchased = Number(totalPurchased) || 0;
  const profit = Number(totalProfit) || 0;
  if (purchased <= 0) return "1 : 0";
  return `1 : ${(profit / purchased).toFixed(2)}`;
}

export function getRealHoldings(portfolioValue, leveragedHoldings) {
  return (
    (Number(portfolioValue) || 0) -
    (Number(leveragedHoldings) || 0)
  );
}

export const regionMap = {
  false: "Global",
  AF: "Africa",
  AS: "Asia",
  AU: "Australia",
  EU: "Europe",
  NA: "North America",
  SA: "South America",
};

export function getRegionName(regionCode) {
  return regionMap[regionCode] || regionCode || "Unknown";
}

export async function getPlayerPortfolio(name, authToken) {
  if (!name) throw new Error("Missing player name");
  if (!authToken) throw new Error("Missing auth token");

  const endpoint = "https://getplayerportfolio-5dhfwyjvzq-uc.a.run.app";

  const res = await fetch(endpoint, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${authToken}`,
    },
    body: JSON.stringify({ name }),
  });

  if (!res.ok) {
    const errorText = await res.text();
    throw new Error(`HTTP ${res.status} - ${errorText}`);
  }

  const data = await res.json();

  return {
    companyHoldings: data.companyHoldings || [],
    itemHoldings: data.itemHoldings || []
  };
}